module.exports = __webpack_public_path__ + "static/media/Dashboard2.fd6f68de.svg";